module.exports = __webpack_public_path__ + "static/media/protecao-notebook_new.8b64700d.svg";